<mat-toolbar class="bg-success">
    <span>Priorytet & Status</span>
    <span class="toolbar-spacer"></span>
    <button class="text-white" mat-icon-button matTooltip="Zamknij" matTooltipPosition="below" [mat-dialog-close]="true"
            aria-hidden="false">
        <mat-icon>close</mat-icon>
    </button>
</mat-toolbar>
<mat-dialog-content>
    <div class="container text-center">
        <h4>Zmiana priorytetu lub statusu zadania na:</h4>
        <div class="pt-2">
            <mat-form-field class="full-width pt-2" appearance="outline">
                <mat-label>Priorytet:</mat-label>
                <mat-select [(value)]="taskPriority">
                    <mat-option value="normalny">normalny</mat-option>
                    <mat-option value="wysoki">wysoki</mat-option>
                    <mat-option value="niski">niski</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="pt-2">
            <mat-form-field class="full-width pt-2" appearance="outline">
                <mat-label>Status:</mat-label>
                <mat-select [(value)]="taskStatus">
                    <mat-option value="utworzone" disabled>utworzone</mat-option>
                    <mat-option value="realizacja">realizacja</mat-option>
                    <mat-option value="wstrzymane">wstrzymane</mat-option>
                    <mat-option value="zrobione">zrobione</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</mat-dialog-content>
<div class="d-flex justify-content-end pb-4">
    <button class="full-width mx-2" mat-raised-button [mat-dialog-close]="true"
            matTooltip="Wyjdź" matTooltipPosition="below" aria-hidden="false">
        <i class="fa-solid fa-xmark"></i> Wyjdź
    </button>
    <button class="full-width mx-2" mat-raised-button color="warn" (click)="changeStatus()"
            matTooltip="Zmień status" matTooltipPosition="below">Zmień <i class="fa-solid fa-check"></i></button>
</div>
